module.exports = __webpack_public_path__ + "img/coming-soon-car.c8a21eff.png";